import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/UserIdsForm/GeneralForm'

export const GeneralPage = (): React.JSX.Element => {
  return <EditContainer />
}
